import React from "react";
import SearchHeader from "./SearchHeader";
import { useState } from "react";
import { auth } from "./firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const Signup = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [email, setEmail] = useState(false);
  const [password, setPassword] = useState(false);
  const handleClick = (e) => {
    e.preventDefault();

    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        console.log(user.email);
        navigate("/login");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <SearchHeader />
      <div className="container py-5 mt-5 d-flex justify-content-center">
        <form onSubmit={handleClick}>
          <div class="form-outline mb-4">
            <input
              type="email"
              id="form2Example1"
              class="form-control"
              onChange={(e) => setEmail(e.target.value)}
            />
            <label class="form-label" for="form2Example1">
              Email address
            </label>
          </div>

          <div class="form-outline mb-4">
            <input
              type="password"
              id="form2Example2"
              class="form-control"
              onChange={(e) => setPassword(e.target.value)}
            />
            <label class="form-label" for="form2Example2">
              Password
            </label>
          </div>
          <button type="submit" class="btn btn-primary btn-block mb-4">
            Sign up
          </button>

          <div class="text-center">
            {error && <p className="text-danger">Wrong Password or email Id</p>}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Signup;
